export default __webpack_public_path__ + "static/media/LAS0230.34I-30563_-23981_0.af7ca9be.jpg";